// extracted by mini-css-extract-plugin
export default {"container":"Create_container__UHHOt","wrapper":"Create_wrapper__Ml4eM","imgWrapper":"Create_imgWrapper__DE2+r","imgData":"Create_imgData__WbRJM"};